<template>
  <div>
    <vue-cropper ref="cropper" :aspect-ratio="360 / 192" :src="img" :cropImage="cropImage"></vue-cropper>
    <!-- <button v-on:tap="cropImage">CROP B</button> -->
    <!-- <div class="crop-button" v-on:tap="cropImage">Save Image</div> -->
  </div>
</template>
<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { eventBus } from '../services/EventBus';
export default {
  name: 'ImageCropperNew',
  props: ['img'],
  components: { VueCropper },
  computed: {
    imageType() {
      return this.img.split(';')[0].substring(5);
    }
  },
  methods: {
    backButtonClicked() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
      // this.$router.push('/');
    },
    cropImage() {
      console.log('cropImage');
      // get image data for post processing, e.g. upload or setting image src
      // this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL(this.imageType);
      this.$refs.cropper.getCroppedCanvas().toBlob(
        cropImg => {
          this.$emit('croppedImg', cropImg);
        },
        this.imageType,
        1
      );
      // this.$router.push('/');
    }
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('Image Cropper back');
      this.backButtonClicked();
    });
    eventBus.$on('confirmButtonClicked', () => {
      this.cropImage();
    });
  },
  mounted() {
    eventBus.$emit('showBackButton');
    // eventBus.$emit('hideBellButton');
    eventBus.$emit('showConfirmButton');
  },
  destroyed() {
    eventBus.$emit('hideBackButton');
    // eventBus.$emit('showBellButton');
    eventBus.$emit('hideConfirmButton');

    eventBus.$off('backButtonClicked');
    eventBus.$off('confirmButtonClicked');
  }
};
</script>
<style lang="scss" scoped>
.crop-button {
  color: #ffff;
  background-color: #c12828;
  padding: 19px 0;
  text-align: center;
  border-radius: $default-border-radius;
  margin: 0 20px;
}
</style>
